// @flow
import { createContext } from 'react';

export const ClusterContext = createContext({});
